import { useContext } from "react";
import Transmitter3 from "../components/Transmitter3";
import Transmitter from "../components/Transmitter";
import "./NK3Wellhead.css";
import ControlValveControlPanel from "../components/ControlValveControlPanel";
import { useState, useEffect } from "react";
import { WellContext } from "../context/WellContext";
import { AlarmContext } from "../context/AlarmContext";
import Valve from "../components/Valve";

import { trackPageVisit } from "../competency/PageTracker";




    /* 🔥 TEMPERATURE TRANSMITTER */
function TemperatureTransmitterOutput({ value, x, y, unit }) {
  const temp = Number(value) || 0;

  let statusClass;

  if (temp < 49) {
    statusClass = "alarm";
  } else if (temp >= 50 && temp <= 99) {
    statusClass = "warning";
  } else if (temp >= 100 && temp <= 280) {
    statusClass = "normal";
  } else if (temp >= 281) {
    statusClass = "alarm";
  } else {
    statusClass = "normal"; // fallback safety
  }

  return (
    <div
      className={`temperature-transmitter-output ${statusClass}`}
      style={{ position: "absolute", left: x, top: y }}
    >
      {temp.toFixed(3)} {unit}
    </div>
  );
}

/* 🔥 PRESSURE TRANSMITTER */
function PressureTransmitterOutput({ value, x, y, unit }) {
  const pressure = Number(value) || 0;

  let statusClass;

  if (pressure < 10) {
    statusClass = "alarm";
  } else if (pressure >= 10 && pressure <= 19) {
    statusClass = "warning";
  } else if (pressure >= 20 && pressure <= 100) {
    statusClass = "normal";
  } else if (pressure >= 101 && pressure <= 149) {
    statusClass = "warning";
  } else if (pressure >= 150) {
    statusClass = "alarm";
  } else {
    statusClass = "normal"; // fallback safety
  }

  return (
    <div
      className={`pressure-transmitter-output ${statusClass}`}
      style={{ position: "absolute", left: x, top: y }}
    >
      {pressure.toFixed(3)} {unit}
    </div>
  );
}


/* ✅ Reusable Indicator */
function Indicator({ x, y, isClosed }) {
  return (
    <svg width="80" height="80" style={{ position: "absolute", left: x, top: y }}>
      <circle
        cx="40"
        cy="30"
        r="17"
        fill={isClosed ? "red" : "lime"}
        stroke="black"
        strokeWidth="2"
      />
    </svg>
  );
}




 
      /* ✅ CONTROL VALVE PERCENTAGE OUTPUT Indicator */
                function ValveOutput({ value, x, y }) {
                return (
                  <div
                    style={{
                      position: "absolute",
                      left: x,
                      top: y,
                      color: "white",
                      fontSize: "10px",
                      padding: "2px 6px",
                      borderRadius: "4px"
                    }}
                  >
                    {value.toFixed(1)}
                  </div>
                );
              }





function NK3Wellhead() {

        useEffect(() => {
  
    trackPageVisit("NK3Wellhead");
  
  }, []);

      const [valveData, setValveData] = useState(() => {
      const saved = localStorage.getItem("nk3_valveData");
      return saved
        ? JSON.parse(saved)
        : {
            FCV_10302: { mode: "Manual", opening: 0, sp: "", pv: "" },
            FCV_10303: { mode: "Manual", opening: 0, sp: "", pv: "" },
            FCV_10304: { mode: "Manual", opening: 0, sp: "", pv: "" },
            FCV_10305: { mode: "Manual", opening: 0, sp: "", pv: "" },
            FCV_10306: { mode: "Manual", opening: 0, sp: "", pv: "" },
            CHK_103: { mode: "Manual", opening: 0, sp: "", pv: "" }
          };
        });
        

         const { valves, toggleValve } = useContext(WellContext);


        useEffect(() => {
            localStorage.setItem("nk3_valveData", JSON.stringify(valveData));
          }, [valveData]);
  

          const { getPT10303, getTT10301 } = useContext(WellContext);

          // ======================================================
          // TT-10301 REALISTIC DCS VALUE
          // ======================================================

          // ACTUAL PROCESS VALUE
          const actualTT10301 =
            getTT10301("NK3");

          // DISPLAY VALUE
          const [tt10301Value, setTT10301Value] =
            useState(actualTT10301);

          // ======================================================
          // REALISTIC DCS MOVEMENT
          // ======================================================

          useEffect(() => {

            const interval = setInterval(() => {

              setTT10301Value(prev => {

                // ==========================================
                // SLOW APPROACH TO ACTUAL VALUE
                // ==========================================

                const tracking =

                  (actualTT10301 - prev) * 0.08;

                // ==========================================
                // SMOOTH OSCILLATION
                // ==========================================

                const wave =

                  Math.sin(Date.now() / 1400) * 0.18;

                // ==========================================
                // SMALL RANDOM NOISE
                // ==========================================

                const noise =

                  (Math.random() * 0.04) - 0.02;

                // ==========================================
                // FINAL VALUE
                // ==========================================

                let next =

                  prev +

                  tracking +

                  wave +

                  noise;

                return Number(next.toFixed(3));
              });

            }, 1000);

            return () => clearInterval(interval);

          }, [actualTT10301]);



          // ======================================================
          // PT-10303 REALISTIC DCS VALUE
          // ======================================================

          // ACTUAL PROCESS VALUE
          const actualPT10303 =
            getPT10303("NK3");

          // DISPLAY VALUE
          const [pt10303Value, setPT10303Value] =
            useState(actualPT10303);

          // ======================================================
          // REALISTIC DCS MOVEMENT
          // ======================================================

          useEffect(() => {

            const interval = setInterval(() => {

              setPT10303Value(prev => {

                // ==========================================
                // SLOW TRACKING TO REAL VALUE
                // ==========================================

                const tracking =

                  (actualPT10303 - prev) * 0.08;

                // ==========================================
                // SMOOTH OSCILLATION
                // ==========================================

                const wave =

                  Math.sin(Date.now() / 1500) * 0.015;

                // ==========================================
                // SMALL RANDOM NOISE
                // ==========================================

                const noise =

                  (Math.random() * 0.006) - 0.003;

                // ==========================================
                // FINAL VALUE
                // ==========================================

                let next =

                  prev +

                  tracking +

                  wave +

                  noise;

                // ==========================================
                // PREVENT NEGATIVE VALUES
                // ==========================================

                if (next < 0)
                  next = 0;

                return Number(next.toFixed(3));
              });

            }, 1000);

            return () => clearInterval(interval);

          }, [actualPT10303]);

          const isSSSVClosed = valves.SSSV_10302;
          const isDHSVClosed = valves.DHSV_10301 === true;

            
          const pt10304Value = !isDHSVClosed ? pt10303Value * 0.915 : 0.03;
          const pt103013Value =pt10304Value * 0.386;
          const tt10302Value = !isDHSVClosed ? tt10301Value * 0.88 : 18;
          const tt10305Value = tt10302Value * 0.90;
          const pt10305Value = pt103013Value * 0.73;
          

          const chkOpening = Number(valveData.CHK_103?.opening) || 0;

          const chkFactor = chkOpening / 100;




        
        const isWellShut = isSSSVClosed || isDHSVClosed;

          const pt10306Target = isWellShut
            ? 0.003
            : pt10305Value * (chkOpening / 100);

          const tt10306Target = isWellShut
            ? 0.003
            : tt10305Value * (chkOpening / 100);




         
           const { wellData, updateWellData, getFIC, getPT, getTT } = useContext(WellContext);

          const nk3Data = wellData?.NK3 || {};




          
          const oilPercent =
            (nk3Data.percentages?.["C5+ liquid hydrocarbons (oil)"] || 0) +
            (nk3Data.percentages?.["Pentanes+ (C5+)"] || 0) +
            (nk3Data.percentages?.["Wax / paraffins"] || 0) +
            (nk3Data.percentages?.["Asphaltenes"] || 0);

          const gasPercent =
            (nk3Data.percentages?.["Dissolved light hydrocarbons C1–C4"] || 0) +
            (nk3Data.percentages?.["Methane (CH4)"] || 0) +
            (nk3Data.percentages?.["Ethane (C2H6)"] || 0) +
            (nk3Data.percentages?.["Propane (C3H8)"] || 0) +
            (nk3Data.percentages?.["Butanes (i-C4 / n-C4)"] || 0);

          const impPercent =
            (nk3Data.percentages?.["Carbon dioxide (CO2)"] || 0) +
            (nk3Data.percentages?.["Nitrogen (N2)"] || 0) +
            (nk3Data.percentages?.["Hydrogen sulfide (H2S)"] || 0) +
            (nk3Data.percentages?.["Formation water (H2O)"] || 0) +
            (nk3Data.percentages?.["Dissolved salts"] || 0) +
            (nk3Data.percentages?.["Sand"] || 0) +
            (nk3Data.percentages?.["Organic acids"] || 0) +
            (nk3Data.percentages?.["Trace metals"] || 0) +
            (nk3Data.percentages?.["Scale-forming ions"] || 0);


            const totalPercent = oilPercent + gasPercent + impPercent || 1;
            

            const totalRate = Number(nk3Data.productionRateInput) || 0;

            const oilBase = totalRate * (oilPercent / totalPercent);
            const gasBase = totalRate * (gasPercent / totalPercent);
            const impBase = totalRate * (impPercent / totalPercent);

            // 🔥 Apply CHK + SSSV logic
            const oilRate = isWellShut ? 0 : oilBase * chkFactor;
            const gasRate = isWellShut ? 0 : gasBase * chkFactor;
            const impRate = isWellShut ? 0 : impBase * chkFactor;


            
            const [fiqNK3, setFiqNK3] = useState(0);

            useEffect(() => {
                const interval = setInterval(() => {

                  // 🔹 Get values
                  const totalRate = Number(nk3Data.productionRateInput) || 0;
                  const chkOpening = Number(valveData.CHK_103?.opening) || 0;
                  const chkFactor = chkOpening / 100;

                  // 🔹 Increment per second
                  const increment = totalRate * chkFactor;

                  // 🔹 Only accumulate if SSSV is OPEN
                  if (!valves.SSSV_10302) {
                    setFiqNK3(prev => prev + increment);
                  }

                }, 1000);

                return () => clearInterval(interval);

              }, [nk3Data.productionRateInput, valveData.CHK_103, valves.SSSV_10302]);

              const resetFIQ = () => {
                  setFiqNK3(0);
                };

                

                const totalFlow = oilRate + gasRate + impRate;

                const isXV10304Open = !valves.XV_10304; // assuming red = closed, lime = open
                const isXV10303Open = !valves.XV_10303;

                let fic10304 = 0;
                let fic10303 = 0;

                if (isXV10304Open && !isXV10303Open) {
                  // Only 10304 open
                  fic10304 = totalFlow;
                  fic10303 = 0;

                } else if (!isXV10304Open && isXV10303Open) {
                  // Only 10303 open
                  fic10304 = 0;
                  fic10303 = totalFlow;

                } else if (isXV10304Open && isXV10303Open) {
                  // Both open → split
                  fic10304 = totalFlow / 2;
                  fic10303 = totalFlow / 2;

                } else {
                  // Both closed
                  fic10304 = 0;
                  fic10303 = 0;
                }

                if (valves.SSSV_10302) {
                  fic10304 = 0;
                  fic10303 = 0;
                }



                
                  useEffect(() => {
                      localStorage.setItem("fic10303", fic10303);
                    }, [fic10303]);

                  useEffect(() => {
                      localStorage.setItem("fic10304", fic10304);
                    }, [fic10304]);



                const isOpen = (tag) => !valves[tag]; // IMPORTANT: normalize logic             
                const xv10308Open = isOpen("XV_10308");

                const fcvOpening = Number(valveData.FCV_10302?.opening ?? 0);
                const fcvFactor = fcvOpening / 100;

                let fic10300 = 0;
                let pt10307 = 0;

                if (xv10308Open) {
                  fic10300 = fcvFactor * 12;
                  pt10307 = fcvFactor * 10;
                } else {
                  fic10300 = 0;
                  pt10307 = 0.003;
                }

                // ===============================
                // CONTROL: FCV-10303 → FIC-10302 & PT-10308
                // ===============================

                const fcv10303Opening = Number(valveData.FCV_10303?.opening ?? 0);
                const fcv10303Factor = fcv10303Opening / 100;

                // optional: if you want XV interlock (recommended for realism)
                const xv10301Open = isOpen("XV_10301");

                let fic10302 = 0;
                let pt10308 = 0;

                if (xv10301Open) {
                  // Flow through FCV-10303
                  fic10302 = fcv10303Factor * 15;   // <-- scaling factor (adjust as needed)
                  pt10308 = fcv10303Factor * 12;    // <-- pressure response
                } else {
                  fic10302 = 0;
                  pt10308 = 0.003; // shutdown leakage / dead pressure
                }




                const updateValveData = (tag, field, value) => {
          setValveData(prev => ({
            ...prev,
            [tag]: {
              ...prev[tag],
              [field]: value
            }
          }));
        };
        
    const [openPanels, setOpenPanels] = useState([]);

    const openPanel = (tag) => {
        if (!openPanels.includes(tag)) {
          setOpenPanels(prev => [...prev, tag]);
        }
      };

      const closePanel = (tag) => {
        setOpenPanels(prev => prev.filter(p => p !== tag));
      };






      
              
                      /* 🔥 ALARM ENGINE TAGS */
              
                      const { evaluateTag } = useContext(AlarmContext);
              
                      useEffect(() => {
                        evaluateTag("TT_10301", tt10301Value);
                        evaluateTag("FIC_10300", fic10300);
                        evaluateTag("FIC_10302", fic10302);
                        evaluateTag("PT_10307", pt10307);
                        evaluateTag("CHK_103", valveData.CHK_103.opening); 
      
      
                      }, [tt10301Value, fic10300, fic10302, pt10307, valveData.CHK_103.opening]);
              
      
              const { updateWellSignals } = useContext(WellContext);
                useEffect(() => {
                  updateWellSignals("NK3", {
                    fic: fic10304,
                    pt: pt10306Target,
                    tt: tt10306Target,
                    fic2: fic10303,
                    pt2: pt10306Target,
                    oil: oilRate,
                    gas: gasRate,
                    water: impRate                  });
                }, [fic10304], [pt10306Target], [oilRate], [gasRate], [impRate], [tt10306Target], [fic10303]);


  return (
    <div className="nk3-container">


      {/* TITLE */}
      <h2 style={{
        position: "absolute",
        top: "0px",
        left: "254px",
        color: "white",
        background: "rgba(39, 18, 233, 0.5)",
        padding: "4px 288px"
      }}>
        NK-3 WELLHEAD
      </h2>

      {/* ================= VALVE TAGS ================= */}

      {/* valve tags */}
      <h2 style={{
        position: "absolute",
        top: "48px",
        left: "90px",
        color: "black",
        fontSize: "10px"
      }}>
        FCV-10306
      </h2>

            {/* Percentage Opening */}
      <h2 style={{position: "absolute", top: "91px", left: "130px", color: "white", fontSize: "10px"}}>%</h2>
        

      {/* valve tags */}
      <h2 style={{
        position: "absolute",
        top: "104px",
        left: "90px",
        color: "black",
        fontSize: "10px"
      }}>
        FCV-10305
      </h2>

            {/* Percentage Opening */}
      <h2 style={{position: "absolute", top: "146px", left: "130px", color: "white", fontSize: "10px"}}>%</h2>

      {/* valve tags */}
      <h2 style={{
        position: "absolute",
        top: "165px",
        left: "128px",
        color: "black",
        fontSize: "10px"
      }}>
        FCV-10304
      </h2>

       {/* Percentage Opening */}
      <h2 style={{position: "absolute", top: "218px", left: "161px", color: "white", fontSize: "10px"}}>%</h2>


      {/* valve tags */}
      <h2 style={{
        position: "absolute",
        top: "227px",
        left: "76px",
        color: "black",
        fontSize: "10px"
      }}>
        XV-10306
      </h2>

        
      {/* valve tags */}
      <h2 style={{
        position: "absolute",
        top: "238px",
        left: "260px",
        color: "black",
        fontSize: "10px"
      }}>
        XV-10307
      </h2>

      {/* valve tags */}
      <h2 style={{
        position: "absolute",
        top: "243px",
        left: "478px",
        color: "black",
        fontSize: "10px"
      }}>
        SSSV-10302
      </h2>

      {/* valve tags */}
      <h2 style={{
        position: "absolute",
        top: "563px",
        left: "465px",
        color: "black",
        fontSize: "10px"
      }}>
        DHSV-10301
      </h2>

      {/* valve tags */}
      <h2 style={{
        position: "absolute",
        top: "105px",
        left: "735px",
        color: "black",
        fontSize: "10px"
      }}>
        FCV-10303
      </h2>

            {/* Percentage Opening */}
      <h2 style={{position: "absolute", top: "165px", left: "769px", color: "white", fontSize: "10px"}}>%</h2>

      {/* valve tags */}
      <h2 style={{
        position: "absolute",
        top: "428px",
        left: "922px",
        color: "black",
        fontSize: "10px"
      }}>
        FCV-10302
      </h2>

            {/* Percentage Opening */}
      <h2 style={{position: "absolute", top: "483px", left: "960px", color: "white", fontSize: "10px"}}>%</h2>


      {/* valve tags */}
      <h2 style={{
        position: "absolute",
        top: "435px",
        left: "1100px",
        color: "black",
        fontSize: "10px"
      }}>
        XV-10308
      </h2>

      {/* valve tags */}
      <h2 style={{
        position: "absolute",
        top: "370px",
        left: "1125px",
        color: "black",
        fontSize: "10px"
      }}>
        XV-10303
      </h2>

      {/* valve tags */}
      <h2 style={{
        position: "absolute",
        top: "270px",
        left: "1125px",
        color: "black",
        fontSize: "10px"
      }}>
        XV-10304
      </h2>

      {/* ================= WHCP INDICATOR TAGS ================= */}

      {/* valve tags */}
      <h2 style={{
        position: "absolute",
        top: "113px",
        left: "1048px",
        color: "black",
        fontSize: "10px"
      }}>
        DHSV-10301
      </h2>

      {/* valve tags */}
      <h2 style={{
        position: "absolute",
        top: "158px",
        left: "1048px",
        color: "black",
        fontSize: "10px"
      }}>
        SSSV-10302
      </h2>

       {/* valve tags */}
      <h2 style={{
        position: "absolute",
        top: "113px",
        left: "1205px",
        color: "black",
        fontSize: "10px"
      }}>
        XV-10304
      </h2>

       {/* valve tags */}
      <h2 style={{
        position: "absolute",
        top: "158px",
        left: "1205px",
        color: "black",
        fontSize: "10px"
      }}>
        XV-10303
      </h2>


      
      {/* ================= TRANSMITTERS TAGS AND UNITS ================= */}
      

      {/* Transmitter tags */}
      <h2 style={{
        position: "absolute",
        top: "188px",
        left: "410px",
        color: "white",
        fontSize: "10px"
      }}>
        PT-10305
      </h2>


      {/* Transmitter tags */}
      <h2 style={{
        position: "absolute",
        top: "227px",
        left: "590px",
        color: "white",
        fontSize: "10px"
      }}>
        CHK_103
      </h2>

            {/* SI unit */}
      <h2 style={{position: "absolute", top: "238px", left: "623px", color: "white", fontSize: "9px"}}>%</h2>


      {/* Transmitter tags */}
      <h2 style={{
        position: "absolute",
        top: "109px",
        left: "539px",
        color: "white",
        fontSize: "10px"
      }}>
        PT-10308
      </h2>


 {/* Transmitter tags */}
      <h2 style={{
        position: "absolute",
        top: "109px",
        left: "629px",
        color: "white",
        fontSize: "10px"
      }}>
        FIC-10302
      </h2>


      {/* Transmitter tags */}
      <h2 style={{
        position: "absolute",
        top: "300px",
        left: "678px",
        color: "white",
        fontSize: "10px"
      }}>
        PT-10306
      </h2>

 
      {/* Transmitter tags */}
      <h2 style={{
        position: "absolute",
        top: "290px",
        left: "766px",
        color: "white",
        fontSize: "11px",
        background:"blue",
      }}>
        MPFT-10300
      </h2>



      {/* Transmitter tags */}
      <h2 style={{
        position: "absolute",
        top: "294px",
        left: "996px",
        color: "white",
        fontSize: "10px",
      }}>
        FIC-10304
      </h2>


      {/* Transmitter tags */}
      <h2 style={{
        position: "absolute",
        top: "382px",
        left: "996px",
        color: "white",
        fontSize: "10px",
      }}>
        FIC-10305
      </h2>


      {/* Transmitter tags */}
      <h2 style={{
        position: "absolute",
        top: "382px",
        left: "856px",
        color: "white",
        fontSize: "10px",
      }}>
        FIQ-10301
      </h2>
     

      {/* Transmitter tags */}
      <h2 style={{
        position: "absolute",
        top: "437px",
        left: "483px",
        color: "white",
        fontSize: "10px"
      }}>
        PT-103013
      </h2>


      {/* Transmitter tags */}
      <h2 style={{
        position: "absolute",
        top: "438px",
        left: "568px",
        color: "white",
        fontSize: "10px"
      }}>
        TT-10301
      </h2>


      {/* Transmitter tags */}
      <h2 style={{
        position: "absolute",
        top: "437px",
        left: "710px",
        color: "white",
        fontSize: "10px"
      }}>
        PT-10307
      </h2>


      {/* Transmitter tags */}
      <h2 style={{
        position: "absolute",
        top: "437px",
        left: "820px",
        color: "white",
        fontSize: "10px"
      }}>
        FIC-10300
      </h2>


      {/* Transmitter tags */}
      <h2 style={{
        position: "absolute",
        top: "501px",
        left: "506px",
        color: "white",
        fontSize: "10px"
      }}>
        PT-10304
      </h2>


      {/* Transmitter tags */}
      <h2 style={{
        position: "absolute",
        top: "501px",
        left: "310px",
        color: "white",
        fontSize: "10px"
      }}>
        PT-10302
      </h2>


      {/* Transmitter tags */}
      <h2 style={{
        position: "absolute",
        top: "604px",
        left: "310px",
        color: "white",
        fontSize: "10px"
      }}>
        PT-10301
      </h2>


      {/* Transmitter tags */}
      <h2 style={{
        position: "absolute",
        top: "604px",
        left: "505px",
        color: "white",
        fontSize: "10px"
      }}>
        PT-10303
      </h2>


       {/* Transmitter tags */}
      <h2 style={{
        position: "absolute",
        top: "604px",
        left: "584px",
        color: "white",
        fontSize: "10px"
      }}>
        TT-10301
      </h2>



      {/* ================= LINE AND PAGE CONNECTOR TAGS ================= */}

      <h2 style={{position: "absolute", top: "170px", left: "859px", color: "black", fontSize: "9px"}}>FROM CORROSION <br />INHIBITOR MANIFOLD</h2>

      <h2 style={{position: "absolute", top: "307px", left: "1279px", color: "white", fontSize: "9px"}}>TO TEST <br />HEADER</h2>

      <h2 style={{position: "absolute", top: "405px", left: "1259px", color: "white", fontSize: "9px"}}>TO PRODUCTION <br />HEADER</h2>

      <h2 style={{position: "absolute", top: "490px", left: "1259px", color: "black", fontSize: "9px"}}>FROM METHANOL <br />SUPPLY MANIFOLD</h2>

      <h2 style={{position: "absolute", top: "280px", left: "8px", color: "black", fontSize: "9px"}}>KILL FLUID</h2>

      <h2 style={{position: "absolute", top: "220px", left: "3px", color: "black", fontSize: "9px"}}>FRESH WATER</h2>

      <h2 style={{position: "absolute", top: "155px", left: "8px", color: "black", fontSize: "9px"}}>COMPLETION <br />BRIME</h2>

      <h2 style={{position: "absolute", top: "98px", left: "8px", color: "black", fontSize: "9px"}}>NITROGEN</h2>



       {/* ================= CONTROL VALVES SVG ================= */}

        {/* FCV-10301 */}
        


        {/* FCV-10302 */}
        <svg width="80" height="50" viewBox="0 0 200 220" className="FCV-10302"
          style={{ position: "absolute", left: 910, top: 450 }} onClick={() => openPanel("FCV_10302")}>
          
          <defs>
            <linearGradient id="metal_10302">
              <stop offset="0%" stopColor="#bdc3c7" />
              <stop offset="50%" stopColor="#ecf0f1" />
              <stop offset="100%" stopColor="#7f8c8d" />
            </linearGradient>
          </defs>

          <path d="M20 60 A80 60 0 0 1 180 60 L180 90 L20 90 Z"
            fill="#eb2a11" stroke="#3498db" strokeWidth="2" />

          <rect x="95" y="90" width="10" height="70" fill="#3d5f2a" />

          <polygon points="20,200 100,150 20,110"
            fill="url(#metal_10302)" stroke="#7f8c8d" strokeWidth="2" />

          <polygon points="180,200 100,150 180,110"
            fill="url(#metal_10302)" stroke="#7f8c8d" strokeWidth="2" />
        </svg>


        {/* FCV-10303 */}
        <svg width="80" height="50" viewBox="0 0 200 220" className="FCV-10303"
          style={{ position: "absolute", left: 715, top: 129 }} onClick={() => openPanel("FCV_10303")}>
          
          <defs>
            <linearGradient id="metal_10303">
              <stop offset="0%" stopColor="#bdc3c7" />
              <stop offset="50%" stopColor="#ecf0f1" />
              <stop offset="100%" stopColor="#7f8c8d" />
            </linearGradient>
          </defs>

          <path d="M20 60 A80 60 0 0 1 180 60 L180 90 L20 90 Z"
            fill="#eb2a11" stroke="#3498db" strokeWidth="2" />

          <rect x="95" y="90" width="10" height="70" fill="#3d5f2a" />

          <polygon points="20,200 100,150 20,110"
            fill="url(#metal_10303)" stroke="#7f8c8d" strokeWidth="2" />

          <polygon points="180,200 100,150 180,110"
            fill="url(#metal_10303)" stroke="#7f8c8d" strokeWidth="2" />
        </svg>


        {/* FCV-10304 */}
        <svg width="80" height="40" viewBox="0 0 200 220" className="FCV-10304"
          style={{ position: "absolute", left: 110, top: 187 }} onClick={() => openPanel("FCV_10304")}>
          
          <defs>
            <linearGradient id="metal_10304">
              <stop offset="0%" stopColor="#bdc3c7" />
              <stop offset="50%" stopColor="#ecf0f1" />
              <stop offset="100%" stopColor="#7f8c8d" />
            </linearGradient>
          </defs>

          <path d="M20 60 A80 60 0 0 1 180 60 L180 90 L20 90 Z"
            fill="#eb2a11" stroke="#3498db" strokeWidth="2" />

          <rect x="95" y="90" width="10" height="70" fill="#3d5f2a" />

          <polygon points="20,200 100,150 20,110"
            fill="url(#metal_10304)" stroke="#7f8c8d" strokeWidth="2" />

          <polygon points="180,200 100,150 180,110"
            fill="url(#metal_10304)" stroke="#7f8c8d" strokeWidth="2" />
        </svg>


        {/* FCV-10305 */}
        <svg width="80" height="40" viewBox="0 0 200 220" className="FCV-10305"
          style={{ position: "absolute", left: 75, top: 122 }} onClick={() => openPanel("FCV_10305")}>
          
          <defs>
            <linearGradient id="metal_10205">
              <stop offset="0%" stopColor="#bdc3c7" />
              <stop offset="50%" stopColor="#ecf0f1" />
              <stop offset="100%" stopColor="#7f8c8d" />
            </linearGradient>
          </defs>

          <path d="M20 60 A80 60 0 0 1 180 60 L180 90 L20 90 Z"
            fill="#eb2a11" stroke="#3498db" strokeWidth="2" />

          <rect x="95" y="90" width="10" height="70" fill="#3d5f2a" />

          <polygon points="20,200 100,150 20,110"
            fill="url(#metal_10305)" stroke="#7f8c8d" strokeWidth="2" />

          <polygon points="180,200 100,150 180,110"
            fill="url(#metal_10305)" stroke="#7f8c8d" strokeWidth="2" />
        </svg>


        {/* FCV-10306 */}
        <svg width="80" height="40" viewBox="0 0 200 220" className="FCV-10306"
          style={{ position: "absolute", left: 74, top: 66 }} onClick={() => openPanel("FCV_10306")}>
          
          <defs>
            <linearGradient id="metal_10306">
              <stop offset="0%" stopColor="#bdc3c7" />
              <stop offset="50%" stopColor="#ecf0f1" />
              <stop offset="100%" stopColor="#7f8c8d" />
            </linearGradient>
          </defs>

          <path d="M20 60 A80 60 0 0 1 180 60 L180 90 L20 90 Z"
            fill="#eb2a11" stroke="#3498db" strokeWidth="2" />

          <rect x="95" y="90" width="10" height="70" fill="#3d5f2a" />

          <polygon points="20,200 100,150 20,110"
            fill="url(#metal_10306)" stroke="#7f8c8d" strokeWidth="2" />

          <polygon points="180,200 100,150 180,110"
            fill="url(#metal_10306)" stroke="#7f8c8d" strokeWidth="2" />
        </svg>

        <svg
            className="CHK-103"
            width="80"
            height="55"
            viewBox="0 0 220 260"
            style={{ position: "absolute", left: 549, top: 252 }}
            onClick={() => openPanel("CHK_103")}
          >

          {/* Top Thin White Accents */}
          <line x1="50" y1="60" x2="200" y2="100" stroke="blue" strokeWidth="12" />
          <line x1="320" y1="60" x2="200" y2="100" stroke="blue" strokeWidth="12" />
          <rect x="50" y="20" width="5" height="30" fill="blue" strokeWidth="12"/>
          
          
          {/* Red Geometric Body Parts */}
          <g fill="#cc0000" stroke="#777" strokeWidth="1">
            {/* Top cap */}
            <rect x="150" y="115" width="100" height="45" />
            
            {/* Upper section */}
            <rect x="110" y="160" width="180" height="55" />
            
            {/* Middle section with notch details */}
            <rect x="110" y="225" width="180" height="100" />
            <rect x="140" y="215" width="20" height="15" />
            <rect x="190" y="215" width="20" height="15" />
            <rect x="240" y="215" width="20" height="15" />
            
            {/* Tapered transition */}
            <polygon points="110,325 290,325 260,370 140,370" />
            
            {/* Lower neck */}
            <rect x="140" y="370" width="120" height="40" />
            
            {/* Base steps */}
            <rect x="130" y="420" width="140" height="25" />
            <rect x="130" y="450" width="140" height="20" />

          </g>
        </svg>

        {/* ✅ MULTIPLE FACEPLATES - RENDER THE CONTROL PANEL */}
        {openPanels.map((tag, index) => (
            <ControlValveControlPanel
              key={tag}
              tag={tag}
              data={valveData[tag] || { mode: "Manual", opening: 0, sp: "", pv: "" }}
              update={updateValveData} // ✅ FOR EDITING
              close={() => closePanel(tag)}
              defaultPosition={{
                x: 300 + index * 40,
                y: 150 + index * 40
              }}
            />
          ))}



              {/* ================= CONTROL VALVE OUTPUTS ================= */}

      <ValveOutput 
        value={Number(valveData.CHK_103?.opening ?? 0)}
        x={590}
        y={242}
      />

      <ValveOutput
        value={Number(valveData.FCV_10302?.opening ?? 0)}
        x={933}
        y={488}
      />

      <ValveOutput
        value={Number(valveData.FCV_10303?.opening ?? 0)}
        x={740}
        y={172}
      />

      <ValveOutput
        value={Number(valveData.FCV_10304?.opening ?? 0)}
        x={134}
        y={224}
      />

      <ValveOutput
        value={Number(valveData.FCV_10305?.opening ?? 0)}
        x={103}
        y={153}
      />

      <ValveOutput
        value={Number(valveData.FCV_10306?.opening ?? 0)}
        x={103}
        y={97}
      />




      
           {/* =================SHUTDOWN VALVES + INDICATORS ================= */}

      {/* SSSV-10302 */}
      <Valve
        tag="SSSV_10302"
        x={490}
        y={260}
        isClosed={valves.SSSV_10302}
        toggle={toggleValve}
        className="SSSV-10302"
      />
      <Indicator
        x={970}
        y={139}
        isClosed={valves.SSSV_10302}
      />

      {/* XV-10304 */}
      <Valve
        tag="XV_10304"
        x={1130}
        y={298}
        isClosed={valves.XV_10304}
        toggle={toggleValve}
        className="XV-10304"
      />
      <Indicator
        x={1126}
        y={98}
        isClosed={valves.XV_10304}
      />

      {/* XV-10303 */}
      <Valve
        className="XV-10303"
        tag="XV_10303"
        x={1130}
        y={399}
        isClosed={valves.XV_10303}
        toggle={toggleValve}
      />
      <Indicator
        x={1126}
        y={143}
        isClosed={valves.XV_10303}
      />

      {/* DHSV-10301 */}
      <Valve
        tag="DHSV_10301"
        x={418}
        y={560}
        r={90}
        isClosed={valves.DHSV_10301}
        toggle={toggleValve}
        className="DHSV-10301"
      />
      <Indicator
        x={970}
        y={95}
        isClosed={valves.DHSV_10301}
      />


      {/* XV-10306 */}
      <Valve
        tag="XV_10306"
        x={81}
        y={248}
        isClosed={valves.XV_10306}
        toggle={toggleValve}
      />

      {/* XV-10307 */}
      <Valve
        tag="XV_10307"
        x={265}
        y={259}
        isClosed={valves.XV_10307}
        toggle={toggleValve}
        className="XV-10307"
      />

      {/* XV-10308 */}
      <Valve
        tag="XV_10308"
        x={1108}
        y={457}
        isClosed={valves.XV_10308}
        toggle={toggleValve}
        className="XV-10308"
      />

      {/* XV-10301 */}
      <Valve
        tag="XV_10301"
        x={522}
        y={180}
        r={90}
        isClosed={valves.XV_10301}
        toggle={toggleValve}
        className="XV-10301"
      />


        <Transmitter
          tag="PT-10303"
          value={pt10303Value}
          x={493}
          y={618}
          unit="MPa"
          max={70}
          HH={60}
          H={55}
          L={0.3}
          LL={0.033}
          c="lime"
          description="PRESSURE OF OIL AND GAS AT THE PARKER ZONE OF NK-3"
        />

        <Transmitter
          tag="TT-10301"
          value={tt10301Value}
          x={573}
          y={618}
          unit="°C"
          max={250}
          HH={225}
          H={200}
          L={25}
          LL={23}
          c="lime"
          description="TEMPERATURE OF OIL AND GAS AT THE PARKER ZONE OF NK-3"
        />

        <Transmitter
          tag="PT-10304"
          value={pt10304Value}
          isClose={valves.DHSV_10301}
          toggle={toggleValve}
          x={493}
          y={514}
          unit="MPa"
          max={70}
          HH={60}
          H={55}
          L={0.3}
          LL={0.033}
          c="lime"
          description="PRESSURE OF OIL AND GAS AT THE PRODUCTION CASING ABOVE THE DOWNHOLE SAFETY VALVE OF NK-3"
        />

        <Transmitter
          tag="PT-103013"
          value={pt103013Value}
          isClose={valves.DHSV_10301}
          toggle={toggleValve}
          x={477}
          y={450}
          unit="MPa"
          max={25}
          HH={20}
          H={18}
          L={0.3}
          LL={0.033}
          c="lime"
          description="PRESSURE OF OIL AND GAS AT THE PRODUCTION CASING BELOW THE NK-3 WELLHEAD"
        />

        <Transmitter
          tag="TT-10301"
          value={tt10302Value}
          x={558}
          y={450}
          unit="°C"
          max={250}
          HH={225}
          H={200}
          L={25}
          LL={23}
          c="lime"
          description="TEMPERATURE OF OIL AND GAS AT THE PRODUCTION CASING BELOW THE NK-3 WELLHEAD"
        />

        <Transmitter
          tag="PT-10305"
          value={pt10305Value}
          isClose={valves.DHSV_10301}
          toggle={toggleValve}
          x={400}
          y={201}
          unit="MPa"
          max={25}
          HH={18}
          H={16}
          L={0.3}
          LL={0.033}
          c="lime"
          description="PRESSURE OF OIL AND GAS FLUID FROM NK-3 WELLHEAD TREE CAP"
        />

        <Transmitter
          tag="TT-10305"
          value={tt10305Value}
          x={400}
          y={212}
          unit="°C"
          max={250}
          HH={225}
          H={200}
          L={25}
          LL={23}
          c="lime"
          description="TEMPERATURE OF OIL AND GAS FLUID FROM NK-3 WELLHEAD TREE CAP"
        />

        <Transmitter
          tag="PT-10306"
          value={pt10306Target}
          controllingValveOpen={pt10305Value}
          toggle={toggleValve}
          x={669}
          y={317}
          unit="MPa"
          max={15}
          HH={14}
          H={10}
          L={0.3}
          LL={0.033}
          c="lime"
          description="PRESSURE OF OIL AND GAS FLUID FROM NK-3 WELLHEAD TO TEST HEADER OR PRODUCTION HEADER"
        />

        <Transmitter
          tag="TT-10306"
          value={tt10306Target}
          controllingValveOpen={tt10305Value}
          toggle={toggleValve}
          x={669}
          y={326}
          unit="°C"
          max={150}
          HH={145}
          H={140}
          L={25}
          LL={23}
          c="lime"
          description="TEMPERATURE OF OIL AND GAS FLUID FROM NK-3 WELLHEAD TO TEST HEADER OR PRODUCTION HEADER"
        />
        
         
        <Transmitter
          tag="FIQ-10301"
          value={fiqNK3.toFixed(2)}
          toggle={toggleValve}
          x={842}
          y={395}
          unit="BOE"
          max={50000}
          HH={38000}
          H={25000}
          L={1.9}
          LL={1}
          c="lime"
          description="FLOWRATE TOTALIZER OF OIL AND GAS FROM NK-3 WELLHEAD AFTER THE CHOKE IN BARREL OF OIL EQUIVALENT"
        />

        <Transmitter
          tag="MPTF-10301"
          value={oilRate.toFixed(2)}
          toggle={toggleValve}
          x={764}
          y={308}
          unit="BPM"
          max={50}
          HH={38}
          H={25}
          L={1.9}
          LL={1}
          c="lime"
          description="FLOWRATE OF CRUDE FROM NK-3 WELLHEAD AFTER THE CHOKE"
        />

        <Transmitter
          tag="MPTF-10302"
          value={gasRate.toFixed(2)}
          toggle={toggleValve}
          x={764}
          y={318}
          unit="SCF/S"
          max={150}
          HH={138}
          H={125}
          L={1.9}
          LL={1}
          c="lime"
          description="FLOWRATE OF GAS FROM NK-3 WELLHEAD AFTER THE CHOKE"
        />

        <Transmitter
          tag="MPTF-10303"
          value={impRate.toFixed(2)}
          toggle={toggleValve}
          x={764}
          y={328}
          unit="LPM"
          max={40}
          HH={38}
          H={25}
          L={1.9}
          LL={1}
          c="lime"
          description="FLOWRATE OF SEDIMENT AND WATER FROM NK-3 WELLHEAD AFTER THE CHOKE"
        />



        <button
          onClick={resetFIQ}
          style={{
            position: "absolute",
            left: 910.5,
            top: 392
          }}
        >
          RESET
        </button>


        <Transmitter
          tag="FIC-10304"
          value={fic10304.toFixed(2)}
          toggle={toggleValve}
          x={988}
          y={308}
          unit="BOE/M"
          max={170}
          HH={168}
          H={150}
          L={1.9}
          LL={1}
          c="lime"
          description="FLOWRATE OF OIL AND GAS FROM NK-3 WELLHEAD TO TEST HEADER"
        />

        <Transmitter
          tag="FIC-10305"
          value={fic10303}
          toggle={toggleValve}
          x={988}
          y={395}
          unit="BOE/M"
          max={170}
          HH={168}
          H={150}
          L={1.9}
          LL={1}
          c="lime"
          description="FLOWRATE OF OIL AND GAS FROM NK-3 WELLHEAD TO PRODUCTION HEADER-2"
        />

        <Transmitter
          tag="PT-10307"
          value={pt10307}
          isClose={valves.XV_10308}
          toggle={toggleValve}
          x={703}
          y={450}
          unit="MPa"
          max={15}
          HH={14}
          H={10}
          L={0.3}
          LL={0.033}
          c="lime"
          description="PRESSURE OF METHANOL FROM METHANOL SUPPLY MANIFOLD"
        />

        <Transmitter
          tag="FIC-10300"
          value={fic10300}
          isClose={valves.XV_10308}
          toggle={toggleValve}
          x={815}
          y={450}
          unit="LPM"
          max={20}
          HH={18}
          H={15}
          L={1.9}
          LL={1}
          c="lime"
          description="FLOWRATE OF METHANOL FROM METHANOL SUPPLY MANIFOLD."
        />


        <Transmitter
          tag="PT-10308"
          value={pt10308}
          isClose={valves.XV_10303}
          toggle={toggleValve}
          x={530}
          y={122}
          unit="MPa"
          max={15}
          HH={14}
          H={10}
          L={0.3}
          LL={0.033}
          c="lime"
          description="PRESSURE OF CORROSION INHIBITOR (WATER-BASED) FROM CORROSION INHIBITOR  MANIFOLD."
        />

        <Transmitter
          tag="FIC-10302"
          value={fic10302}
          isClose={valves.XV_10303}
          toggle={toggleValve}
          x={623}
          y={122}
          unit="LPM"
          max={20}
          HH={18}
          H={15}
          L={1.9}
          LL={1}
          c="lime"
          description="FLOWRATE OF CORROSION INHIBITOR (WATER-BASED) FROM CORROSION INHIBITOR  MANIFOLD."
        />

      
 





       


      

    </div>
  );
}

export default NK3Wellhead;